<template>
  <div class="backdrop-container" v-if="show">
    <div class="backdrop-loader"></div>
    <div class="backdrop-text">{{ label }}</div>
  </div>
</template>

<script>
    import EventBus from '../services/event-bus';

    export default {
        data() {
            return {
                show: false,
                label: null,
                defaults: {
                    label: 'Chargement...'
                }
            }
        },

        mounted() {
            EventBus.$on('backdrop.show', (options) => {
                this.label = options.label || this.defaults.label;
                this.show = true;
            });
            EventBus.$on('backdrop.hide', () => this.show = false);
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/BackdropLoader.vue